import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useConnectedShopsQuery = createQueryHook(ShopsApiClient.getConnectedShops, {
  queryKey: ['connectedShops'],
})
